import { render, staticRenderFns } from "./ReporteLiquidaciones.vue?vue&type=template&id=12fb978a&scoped=true"
import script from "./ReporteLiquidaciones.vue?vue&type=script&lang=js"
export * from "./ReporteLiquidaciones.vue?vue&type=script&lang=js"
import style0 from "./ReporteLiquidaciones.vue?vue&type=style&index=0&id=12fb978a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb978a",
  null
  
)

export default component.exports